import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { ASSESSMENTS_ERROR, CREATE_ASSESSMENT, CREATE_ASSESSMENT_RECORD, CREATING_ASSESSMENT, CREATING_ASSESSMENT_RECORD, GETTING_ASSESSMENTS, GETTING_ASSESSMENT_RECORDS, GET_ASSESSMENTS, GET_ASSESSMENT_RECORDS, SET_SUCCESS, UPDATE_ASSESSMENT, UPDATING_ASSESSMENT } from "../types"


export const fetchAssessments = (filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/assessments?expand=term,academicSession,createdBy`

        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_ASSESSMENTS,
            payload: true
        })

        const response = await axios.get(url, { headers })

        dispatch({
            type: GET_ASSESSMENTS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: ASSESSMENTS_ERROR,
            error
        })
    }
}

export const createAssessment = (payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_ASSESSMENT,
            payload: true
        })
        
        const response = await axios.post(`${baseUrl}/assessments`, payload, { headers })
        
        dispatch({
            type: CREATE_ASSESSMENT,
            payload: response.data
        })

        dispatch({
            type: SET_SUCCESS,
            payload: 'New assessment created successfully!'
        })
    }
    catch(error){
        dispatch({
            type: ASSESSMENTS_ERROR,
            error
        })
    }
}

export const clearCreatedAssessment = () => async (dispatch) => {    
    dispatch({
        type: CREATE_ASSESSMENT,
        payload: null
    })
}


export const updateAssessment = (id, payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_ASSESSMENT,
            payload: true
        })
        
        const response = await axios.patch(`${baseUrl}/assessments/${id}`, payload, { headers })
        
        dispatch({
            type: UPDATE_ASSESSMENT,
            payload: response.data
        })

        dispatch({
            type: SET_SUCCESS,
            payload: 'Assessment updated successfully!'
        })
    }
    catch(error){
        dispatch({
            type: ASSESSMENTS_ERROR,
            error
        })
    }
}

export const clearUpdatedAssessment = () => async (dispatch) => {    
    dispatch({
        type: UPDATE_ASSESSMENT,
        payload: null
    })
}

export const fetchAssessmentRecords = (filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/assessment-records?expand=student,subject,recordedBy,class.class,assessment`

        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_ASSESSMENT_RECORDS,
            payload: true
        })

        const response = await axios.get(url, { headers })

        dispatch({
            type: GET_ASSESSMENT_RECORDS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: ASSESSMENTS_ERROR,
            error
        })
    }
}

export const createAssessmentRecord = (payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_ASSESSMENT_RECORD,
            payload: true
        })
        
        const response = await axios.post(`${baseUrl}/assessment-records`, payload, { headers })
        
        dispatch({
            type: CREATE_ASSESSMENT_RECORD,
            payload: response.data
        })

        dispatch({
            type: SET_SUCCESS,
            payload: 'New assessment record created successfully!'
        })
    }
    catch(error){
        dispatch({
            type: ASSESSMENTS_ERROR,
            error
        })
    }
}

export const clearCreatedAssessmentRecord = () => async (dispatch) => {    
    dispatch({
        type: CREATE_ASSESSMENT_RECORD,
        payload: null
    })
}
